class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}
 
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`) || this.querySelector(`#Drawer-quantity-${id}`);
    if (input) {
    input.value = input.getAttribute('value');
      const quantityInput = input.closest('quantity-input');
      if (quantityInput && typeof quantityInput.validateQtyRules === 'function') {
        quantityInput.validateQtyRules();
      }
    }
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  getA5SampleLimitConfig() {
    const container = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (!container) return { enforce: false, limit: 0, count: 0 };
    return {
      enforce: container.hasAttribute('data-enforce-a5-limit'),
      limit: parseInt(container.getAttribute('data-a5-sample-limit')) || 10,
      count: parseInt(container.getAttribute('data-a5-sample-count')) || 0,
    };
  }

  calculateA5SamplesInCart() {
    let total = 0;
    const rows = this.querySelectorAll('[data-is-a5-sample="true"]');
    rows.forEach((row) => {
      const input = row.querySelector('.quantity__input');
      if (input) {
        total += parseInt(input.getAttribute('value')) || 0;
      }
    });
    return total;
  }

  isA5Sample(index) {
    const row = document.getElementById(`CartItem-${index}`) || document.getElementById(`CartDrawer-Item-${index}`);
    return row && row.getAttribute('data-is-a5-sample') === 'true';
  }

  validateA5SampleLimit(index, newQuantity, event) {
    const config = this.getA5SampleLimitConfig();
    if (!config.enforce) return '';

    const currentTotal = this.calculateA5SamplesInCart();
    const currentItemQty = parseInt(event.target.getAttribute('value')) || 0;
    const delta = newQuantity - currentItemQty;
    const newTotal = currentTotal + delta;

    if (delta > 0 && newTotal > config.limit) {
      this.toggleA5LimitWarning(true);
      return `Maximum of ${config.limit} A5 swatch samples allowed in cart`;
    }

    this.toggleA5LimitWarning(false);
    return '';
  }

  toggleA5LimitWarning(show) {
    const banner =
      document.getElementById('Cart-A5SampleBanner') || document.getElementById('CartDrawer-A5SampleBanner');
    if (!banner) return;

    if (show) {
      banner.style.display = 'flex';
      banner.classList.remove('a5-sample-banner--shake');
      void banner.offsetWidth;
      banner.classList.add('a5-sample-banner--shake');
    } else {
      banner.style.display = 'none';
      banner.classList.remove('a5-sample-banner--shake');
    }
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (!message && this.isA5Sample(index)) {
      message = this.validateA5SampleLimit(index, inputValue, event);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.toggleA5LimitWarning(false);
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          // Sync quantity across cart page and cart drawer inputs for this line only.
          // Lines can share a variant (e.g. same SKU with different properties), so match on line too.
          if (variantId && updatedValue !== undefined) {
            document.querySelectorAll(`[data-quantity-variant-id="${variantId}"][data-index="${line}"]`).forEach((input) => {
              input.value = updatedValue;
              input.setAttribute('value', updatedValue);
              input.setAttribute('data-cart-quantity', updatedValue);
            });
          }

          // Sync line item price across cart page and cart drawer
          if (updatedValue !== undefined) {
            if (this.tagName === 'CART-DRAWER-ITEMS') {
              // Drawer was re-rendered — copy its updated price to the cart page
              const drawerPriceWrapper = document.querySelector(`#CartDrawer-Item-${line} .cart-item__price-wrapper`);
              if (drawerPriceWrapper) {
                document.querySelectorAll(`#CartItem-${line} .cart-item__price-wrapper`).forEach((wrapper) => {
                  wrapper.innerHTML = drawerPriceWrapper.innerHTML;
                });
              }
            } else {
              // Cart page was re-rendered — copy its updated price to the drawer
              const cartPagePriceWrapper = document.querySelector(`#CartItem-${line} .cart-item__price-wrapper`);
              const drawerPriceWrapper = document.querySelector(`#CartDrawer-Item-${line} .cart-item__price-wrapper`);
              if (cartPagePriceWrapper && drawerPriceWrapper) {
                drawerPriceWrapper.innerHTML = cartPagePriceWrapper.innerHTML;
              }
            }
          }

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.price-skeleton').forEach((el) => el.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const selectors = [`#CartItem-${line}`, `#CartDrawer-Item-${line}`];
    selectors.forEach((sel) => {
      const row = this.querySelector(sel);
      if (!row) return;
      row.querySelectorAll('.price-loading-wrapper').forEach((el) => el.classList.add('is-loading'));
    });

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const selectors = [`#CartItem-${line}`, `#CartDrawer-Item-${line}`];
    selectors.forEach((sel) => {
      const row = this.querySelector(sel);
      if (!row) return;
      row.querySelectorAll('.price-loading-wrapper').forEach((el) => el.classList.remove('is-loading'));
    });
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
